import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { fork } from 'child_process';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin, Subject } from 'rxjs';
import { CoreService } from 'src/app/core-service/services/core-service.service';
import { ModalConstants } from 'src/assets/global-constants/modal-constants';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../services/common.service';
import { CustomConfirmDialogueComponent } from '../custom-confirm-dialogue/custom-confirm-dialogue.component';
import { SearchUpdateConfirmationComponent } from '../search-update-confirmation/search-update-confirmation.component';

@Component({
  selector: 'app-core-employee-search',
  templateUrl: './core-employee-search.component.html',
  styleUrls: ['./core-employee-search.component.scss']
})
export class CoreEmployeeSearchComponent implements OnInit {
  salesAssignment: boolean = true;
  coreServiceType: any = [];
  states: any = [];
  regions: any = [];
  pcnumbers : any = [];
  officeNames : any = [];
  infoheading : boolean = true;
  coreEmployeeSearchForm!: UntypedFormGroup;
  selectedCountryAdvanced: any = [];
  selectedOfficeName: any;
  filteredEmployee: any = [];
  filteredEmployees: any = [];
  filteredPCNumbers: any = [];
  filteredOfficeNames: any = [];
  employeeList: any = [];
  countries: any = [];
  assetsUrl : string = '';
  assignmnt: boolean = true;
  @Output() onAddNonEmployeeEmit = new EventEmitter();
  @Output() onMobileChange = new EventEmitter();
  @Output() onAssignmentChangeEmit = new EventEmitter();
  @Output() searchEmployeeEmit = new EventEmitter();
  @Input() isMobileDevice: any;
  selectedCoreServiceType = '';
  lastSelectedCoreServiceType = '';
  changeCoreServiceTypeEvent: any;
  selectedState: any;
  selectedRegion: any;
  selectedPCNumber= '';
  selectedOffice: any;
  isLOBUser : boolean  = false;
  isSuperAdminUser : boolean  = false;
  public searchEmployee$ = new Subject<string>();
  public searchEmployee!: string;
  currentSearchData: any;
  submitDisable: any = false;
  disaledSubmitBtnSales: boolean = true;
  selectedRegions: any;
  lastSearchEmployee: any;
  @ViewChild('exceptionModal', { static: true })
  public exceptionModal: CustomConfirmDialogueComponent | any;
  @ViewChild('searchConfirmationModal', {static: true})
  public searchConfirmationModal: SearchUpdateConfirmationComponent | any;
  @ViewChild('changeCoreServiceConfirmationModal', {static: true})
  public changeCoreServiceConfirmationModal: SearchUpdateConfirmationComponent | any;
  isExceptionModal: boolean = true;
  hideNonEmployeeBtn: boolean = true;
  searchedFlag: boolean = false;
  changeSelectedCoreServiceType: boolean = true;
  flag: boolean = false;
  @ViewChild('changeSearchByModal', {static: true})
  public changeSearchByModal: SearchUpdateConfirmationComponent | any;
  searchByType: boolean = true;
  constructor(private formBuilder: UntypedFormBuilder,
    private commonService : CommonService,
    private spinner: NgxSpinnerService,
    private coreService: CoreService,
    private route: Router,
    private cdr: ChangeDetectorRef
    ) { }

  ngOnInit(): void {
    this.assetsUrl = environment.assetsUrl;
    this.isLOBUser = this.commonService.isLOBUser();
    this.isSuperAdminUser = this.commonService.isSuperAdminUser();
    this.initializecoreEmployeeSearchForm();
    this.getDropdownValues();
    this.initializeSearchData();
      
    this.commonService.subscribeChangeCoreAssignment((res: any) => {
      if (res) {
        this.updateChangedCoreAssignment();
      } else {
        this.searchedFlag = false;
        this.coreEmployeeSearchForm.controls['type'].setValue('null');
          this.coreEmployeeSearchForm.controls['employeeName'].setValue('');
          this.flag = this.coreService.getDataChangeFlag();
          this.changeSelectedCoreServiceType = true;
          this.hideNonEmployeeBtn = true;
          if((this.selectedCoreServiceType === ''  || this.selectedCoreServiceType === '1') && this.changeSelectedCoreServiceType) {
              this.coreEmployeeSearchForm.controls['employeeName'].disable();
              this.getData();
          } else {
            this.coreEmployeeSearchForm.controls['employeeName'].enable();
          }
          this.disaledSubmitBtnSales = true;
      }
      this.spinner.hide();
    });    
    
    this.populateCoreServiceSearchDetails();
  }

  getData() {
    this.flag = this.coreService.getDataChangeFlag();
    return this.flag;
  }
  /** to update the core assignment radio button and navigate to update non employee page with input fields preset */
  updateChangedCoreAssignment(): void {
    const data = this.commonService.getCurrentAssociationDetails();
    this.onSearchByTypeChange(true);
    this.getEmployeeList();
    let list = data.associationList[0];
    this.coreEmployeeSearchForm.controls.type.setValue(list.coreServiceId.toString());
    this.filterEmployee({query: list.coreServiceId})
    let obj = {id: list.employeeNumber.toString(), value: data.editValue.firstName + ' ' + data.editValue.lastName,"extendedProperty": null};
    this.coreEmployeeSearchForm.controls.employeeName.patchValue(obj);
    this.coreEmployeeSearchForm.updateValueAndValidity();
    this.changeSelectedCoreServiceType = false;
    this.commonService.redirectToNonEmployeeEdit.next(true);
    this.searchUpdate();
  }

  initializeSearchData() {
    this.currentSearchData = {
      stateId : '', 
      regionName: '', 
      pcNumber: '' ,
      coreServiceId: '' ,                  
    }
    this.submitDisable = true;
  }

  /* initialize search agent form */
  initializecoreEmployeeSearchForm() {
    this.coreEmployeeSearchForm = this.formBuilder.group({
      searchBy: new UntypedFormControl(true),
      type: new UntypedFormControl(null),
      employeeName: new UntypedFormControl(''),
      state: new UntypedFormControl(null),
      region: new UntypedFormControl(null),
      pcnum: new UntypedFormControl(''),
      officeName: new UntypedFormControl('')
    });
  }

  /* On search by type change */
  onSearchByTypeChange(searchByType: boolean) {
    this.cdr.detectChanges();
    this.searchedFlag = false;    
    this.searchByType = searchByType;
    if (this.coreService.getFormUpdatedStatus()) {
      this.changeSearchByModal.showModal();
    } else {
      this.onChangeSearchBy();
    }
  }

  /** call on cancel of navigation pop up if search by is changed */
  onChangeSearchByCancel(): void {
    if (this.searchByType) {
      this.salesAssignment = false;
      this.coreEmployeeSearchForm.controls.searchBy.patchValue(false);
    } else {
      this.salesAssignment = true;
      this.coreEmployeeSearchForm.controls.searchBy.patchValue(true);
    }
  }

  /** call on agreeing of navigation pop up if search by is changed or when the search by selection is changed */
  onChangeSearchBy(): void {
    this.coreService.setFormUpdateStatus(false);
    this.coreService.setDataChangeFlag(false);
    this.getData()
    if (!this.searchByType) {
      this.assignmnt = false;
      this.infoheading = true;
      this.submitDisable = true;
      this.coreEmployeeSearchForm.controls['type'].setValue('');
      this.initializeSearchData();
      this.employeeList = [];
      this.disaledSubmitBtnSales = true;
    }else{
      this.assignmnt = true;
      this.disaledSubmitBtnSales = true;
      this.coreEmployeeSearchForm.controls['type'].setValue('');
      this.selectedCoreServiceType = '';
    }
    this.coreEmployeeSearchForm.reset();
    this.onAssignmentChangeEmit.emit(this.assignmnt);
    this.salesAssignment = this.searchByType;
    this.initializeSearchData();
    this.hideNonEmployeeBtn = true;
  }

  /**
 * filter employee list
 */
   filterEmployee(event: any) {
     this.disaledSubmitBtnSales = true;
    let filtered: any[] = [];
    let query = event.query;
    if(this.employeeList?.length > 0) {
      for (let i = 0; i < this.employeeList.length; i++) {
        let country = this.employeeList[i];
        if (country.value?.toLowerCase().includes(query?.toLowerCase())) {
          filtered.push(country);
        }
      }
      this.filteredEmployees = filtered;
    } else {
      this.filteredEmployees = [];
    }
  }

 /** filter pcnumber autocomplete */
filterPCNumber(event: any) {
  let a: any[] = [];
  let query = event.query;
  for (let row of this.officeNames) {
    let pcnum = row;
    if (pcnum.id?.toLowerCase().includes(query?.toLowerCase())) {
      a.push(pcnum);
    }
  }
  this.filteredPCNumbers = a;
}


/** filter office name autocomplete */
filterOfficeName(event: any) {
  let filter: any[] = [];
  let query = event.query;
  for (let i = 0; i < this.officeNames.length; i++) {
    let officeName = this.officeNames[i];
    if (officeName.value?.toLowerCase().includes(query?.toLowerCase())) {
      filter.push(officeName);
    }
  }
  this.filteredOfficeNames = filter;
}


  /** add non employee event  */
  AddNonEmployee() {
    this.coreService.setLastSearchEmployee(null)
    this.onAddNonEmployeeEmit.emit(null);
    this.infoheading = false;
    this.searchedFlag = true;
  }

  /** search for core service employee */
  searchCoreEmployee() {
    if(this.coreService.getFormUpdatedStatus() && !this.route.url.includes('nonEmployeeProfile')) {
      this.searchConfirmationModal.showModal();
      this.searchedFlag = true;
    } else {
      this.searchUpdate();
    }   
  }

  searchUpdate() {
    this.searchedFlag = true;
    this.coreService.setFormUpdateStatus(false);
    this.coreService.setDataChangeFlag(false);
    this.flag = this.coreService.getDataChangeFlag();
    if (!this.salesAssignment) {
      this.coreService.searchUpdate$.next(true);
    }
    this.hideNonEmployeeBtn = true;
    this.lastSearchEmployee = this.coreEmployeeSearchForm.value;
    if (this.salesAssignment) {
      this.lastSearchEmployee['salesAssignement'] = true;
      this.lastSearchEmployee['currentAssignment'] = false;
    } else {
      this.lastSearchEmployee['salesAssignement'] = false;
      this.lastSearchEmployee['currentAssignment'] = true;
      this.lastSearchEmployee['currentAssinmentData'] = this.currentSearchData;
    }
    this.lastSearchEmployee['serviceType'] = this.coreServiceType.filter((x: any) => x.id === this.coreEmployeeSearchForm.value.type).map((y: any) => y.value)[0];
    this.currentSearchData['type'] = this.coreEmployeeSearchForm.value.type;
    this.currentSearchData['coreServiceId'] = this.coreEmployeeSearchForm.value.type;
    this.currentSearchData['regionName'] = this.regions.filter((x: any) => x.id === this.coreEmployeeSearchForm.value.region).map((y: any) => y.value)[0];
    this.currentSearchData['stateId'] = this.coreEmployeeSearchForm.value.state === 'null' ? null : this.coreEmployeeSearchForm.value.state;
    this.currentSearchData['pcNumber'] = this.coreEmployeeSearchForm.value.pcnum === 'null' ? null : this.coreEmployeeSearchForm.value.pcnum;
    this.lastSearchEmployee['currentAssinmentData'] = this.currentSearchData
    this.coreService.setLastSearchEmployee(this.lastSearchEmployee);
    sessionStorage.setItem('coreServiceSearchData', JSON.stringify(this.lastSearchEmployee));
    this.searchEmployeeEmit.emit(this.lastSearchEmployee);
    this.infoheading = false;
  }

  /** change core service type dropdown evenet */
  changeCoreService(event: any) {
    if(this.coreService.getFormUpdatedStatus()) {
      this.changeCoreServiceTypeEvent = event;
      this.changeCoreServiceConfirmationModal.showModal('');
    } else {
      this.changeCoreServiceModal(event);
      this.searchedFlag = false
    } 
  }

  /** update core service type  */
  updateCoreServiceType(event: any) {
    this.selectedCoreServiceType = event.target.value;
    this.lastSelectedCoreServiceType = this.selectedCoreServiceType;
    this.coreService.setFormUpdateStatus(false);
    if(this.selectedCoreServiceType === '1') {
      this.coreEmployeeSearchForm.controls['employeeName'].enable();
      this.hideNonEmployeeBtn = false;
    } else {
      this.hideNonEmployeeBtn = true;
    }
    this.coreService.setSelectedCoreServiceId(this.selectedCoreServiceType);   
    if(this.salesAssignment) {
      this.disaledSubmitBtnSales = true;
      this.getEmployeeList();
      this.coreEmployeeSearchForm.controls['employeeName'].setValue('')
    }
    if(this.selectedCoreServiceType && !this.salesAssignment) {
      this.submitDisable = false;
      this.currentSearchData.coreServiceId = this.selectedCoreServiceType;
      if(this.coreEmployeeSearchForm.controls['pcnum'].value === '' || this.coreEmployeeSearchForm.controls['officeName'].value === '' ) {
        this.coreEmployeeSearchForm.controls['officeName'].setValue('');
        this.coreEmployeeSearchForm.controls['pcnum'].setValue('');
      }
      this.currentSearchData = {
        stateId : this.coreEmployeeSearchForm.controls['state'].value === "null" ? null : this.coreEmployeeSearchForm.controls['state'].value,
        regionName: this.coreEmployeeSearchForm.controls['region'].value ? this.getRegionName(this.coreEmployeeSearchForm.controls['region'].value) : null, 
        pcNumber: this.coreEmployeeSearchForm.controls['officeName'].value ? this.coreEmployeeSearchForm.controls['officeName'].value.id : null ,
        coreServiceId: this.selectedCoreServiceType === "null" ? null : this.selectedCoreServiceType ,                  
      }
      this.submitDisable = Object.values(this.currentSearchData).every(o => o === null || o === undefined);
    } 
  }

  /** change state dropdown event */
  changeState(event: any) {
    this.selectedState = event.target.value;
    this.coreService.setSelectedStateId(this.selectedState);  
    if(this.selectedState && !this.salesAssignment) {
      this.submitDisable = false;
      this.currentSearchData.stateId = this.selectedState;
      if(this.coreEmployeeSearchForm.controls['pcnum'].value === '' || this.coreEmployeeSearchForm.controls['officeName'].value === '' ) {
        this.coreEmployeeSearchForm.controls['officeName'].setValue('');
        this.coreEmployeeSearchForm.controls['pcnum'].setValue('');
      }
      this.currentSearchData = {
        stateId :  this.selectedState === "null" ? null : this.selectedState ,
        regionName: this.coreEmployeeSearchForm.controls['region'].value ? this.getRegionName(this.coreEmployeeSearchForm.controls['region'].value) : null, 
        pcNumber: this.coreEmployeeSearchForm.controls['officeName'].value ? this.coreEmployeeSearchForm.controls['officeName'].value.id : null ,
        coreServiceId: this.coreEmployeeSearchForm.controls['type'].value === "null" ? null : this.coreEmployeeSearchForm.controls['type'].value,                
      }
      this.submitDisable = Object.values(this.currentSearchData).every(o => o === null || o === undefined);
    }
  }

  /**
   * @Method to get region name for selected region Id
   * @param id 
   */
  getRegionName(id: any): any {
    let RegionData;
    if(this.regions){
      RegionData = this.regions.filter((ele:any) =>  Number(ele.id)  === Number(this.coreEmployeeSearchForm.controls['region'].value)).map((data:any) => data.value);
      return RegionData[0];
    }
  }
  /** change region dropdown event */
  changeRegion(event: any) {
    this.selectedRegion = event.target.value;
    this.coreService.setSelectedCoreRegionId(this.selectedRegion);  
    if(this.selectedRegion && !this.salesAssignment) {
      this.submitDisable = false;
      this.currentSearchData.regionName = this.getRegionName(this.selectedRegion);
      if(this.coreEmployeeSearchForm.controls['pcnum'].value === '' || this.coreEmployeeSearchForm.controls['officeName'].value === '' ) {
        this.coreEmployeeSearchForm.controls['officeName'].setValue('');
        this.coreEmployeeSearchForm.controls['pcnum'].setValue('');
      }
      this.currentSearchData = {
        stateId : this.coreEmployeeSearchForm.controls['state'].value === "null" ? null : this.coreEmployeeSearchForm.controls['state'].value,
        regionName: this.coreEmployeeSearchForm.controls['region'].value ? this.getRegionName(this.selectedRegion) : null, 
        pcNumber: this.coreEmployeeSearchForm.controls['officeName'].value  ? this.coreEmployeeSearchForm.controls['officeName'].value.id : null ,
        coreServiceId: this.coreEmployeeSearchForm.controls['type'].value === "null" ? null : this.coreEmployeeSearchForm.controls['type'].value,                  
      }
      this.submitDisable = Object.values(this.currentSearchData).every(o => o === null || o === undefined);
    } 
    this.coreService.setSelectedCoreServiceId(this.selectedCoreServiceType); 
    this.coreEmployeeSearchForm.controls['employeeName'].setValue('');
    if(this.salesAssignment) {
    this.getEmployeeList();
    }
  }

  /** get employee list based on core service */
  getEmployeeList() {
    this.spinner.show();
    this.coreService.getEmployeeBasedOnCoreService().subscribe((res: any) => {
      this.employeeList = res.body;
      this.spinner.hide();
    }, (err) => {
      this.errorCodeExecuted();
    })
  }

  /** get dropdown values for current assignment search */
  getDropdownValues() {
    let param = `UserName=${this.commonService.getSavedUserInfo()?.userPrincipalName},SiteUserTyp=${this.commonService.getUserRoleObjr()?.siteUserType}`;
    this.spinner.show();
    forkJoin([
      this.commonService.getCoreServiceList(param),
      this.commonService.getRegionList(param),
      this.commonService.getcoreServiceOfficeNumer(''),
      this.commonService.getStateList(param)
    ]).subscribe(([res0,res1, res2, res3]: [any, any, any, any]) => {
      this.coreServiceType = res0.filter(( item : any) => item.value !== "Vacation Rentals");;
      this.regions = res1;
      this.officeNames = res2.body;
      this.states = res3;
      this.coreService.setOfficelist(this.officeNames);
      this.coreService.setRegionlist(this.regions);
      this.coreService.setStatelist(this.states);
      this.updateFormResponsive()
      this.spinner.hide();
    }, (error: any) => {
      this.errorCodeExecuted();
    });
    
    
  }

  /** on select of PC number dropdown */
  selectPCNumber(event: any) {
    this.selectedPCNumber = event.value?.id;
    this.coreEmployeeSearchForm.controls['pcnum'].setValue(event.value?.id);
    this.coreEmployeeSearchForm.controls['officeName'].setValue(event.value?.value);
    if(this.selectedPCNumber && !this.salesAssignment) {
      this.submitDisable = false;
      this.currentSearchData.pcNumber = this.selectedPCNumber;
      this.currentSearchData = {
        stateId : this.coreEmployeeSearchForm.controls['state'].value === "null" ? null : this.coreEmployeeSearchForm.controls['state'].value,
        regionName: this.coreEmployeeSearchForm.controls['region'].value ? this.getRegionName(this.coreEmployeeSearchForm.controls['region'].value) : null, 
        pcNumber: this.coreEmployeeSearchForm.controls['officeName'].value ? this.selectedPCNumber : null ,
        coreServiceId: this.coreEmployeeSearchForm.controls['type'].value === "null" ? null : this.coreEmployeeSearchForm.controls['type'].value,                   
      }
      this.submitDisable = Object.values(this.currentSearchData).every(o => o === null || o === undefined);      
    }

  }

  /** on select of Office dropdown */
  selectOffice(event: any) { 
    this.selectedOffice = event.value.value;
    this.coreEmployeeSearchForm.controls['pcnum'].setValue(event.value?.id);
    this.coreEmployeeSearchForm.controls['officeName'].setValue(event.value?.value);
    if(this.selectedOffice && !this.salesAssignment) {
      this.submitDisable = false;
      this.currentSearchData.pcNumber = this.selectedPCNumber;
      this.currentSearchData = {
        stateId : this.coreEmployeeSearchForm.controls['state'].value === "null" ? null : this.coreEmployeeSearchForm.controls['state'].value,
        regionName: this.coreEmployeeSearchForm.controls['region'].value ? this.getRegionName(this.coreEmployeeSearchForm.controls['region'].value) : null, 
        pcNumber: this.coreEmployeeSearchForm.controls['officeName'].value ? this.selectedOffice : null ,
        coreServiceId: this.coreEmployeeSearchForm.controls['type'].value === "null" ? null : this.coreEmployeeSearchForm.controls['type'].value,                  
      }
      this.submitDisable = Object.values(this.currentSearchData).every(o => o === null || o === undefined);
    }
  }

  /** error code executed after api failed  */
  errorCodeExecuted() {
    this.spinner.hide();
    this.isExceptionModal = false;
    this.exceptionModal.showModal(ModalConstants.CONTACT_TECHNICAL_SUPPORT, false);
  }

  /**
   * Method to clear searchfilters
   */
  onClear(){
    this.coreEmployeeSearchForm.reset();
    this.coreEmployeeSearchForm.controls.searchBy.patchValue(false);
    this.initializeSearchData();
  }


  
  /** update responsive search form */
  updateFormResponsive() {
    const lastEmployeeSearch = this.coreService.getLastSearchEmployee()
    if (this.commonService.isMobileDevice() && lastEmployeeSearch) {
      this.salesAssignment = lastEmployeeSearch.salesAssignement;
      if (lastEmployeeSearch.pcnum) {
        this.selectPCNumber(lastEmployeeSearch.pcnum);
      }
      this.coreEmployeeSearchForm.controls['type'].setValue(lastEmployeeSearch.type);
      this.coreEmployeeSearchForm.controls['region'].setValue(lastEmployeeSearch.region);
      this.coreEmployeeSearchForm.controls['state'].setValue(lastEmployeeSearch.state);
      this.coreEmployeeSearchForm.controls['pcnum'].setValue(lastEmployeeSearch.pcnum);

      this.selectedCoreServiceType = lastEmployeeSearch.type;
      this.coreEmployeeSearchForm.controls['employeeName'].setValue(lastEmployeeSearch.employeeName);
      if (this.salesAssignment) {
        this.disaledSubmitBtnSales = false;
      } else {
        this.submitDisable = false;
      }
    }
  }

  enableSubmitBtn() {
    this.disaledSubmitBtnSales = false;
  }
 
  /**
   * Method triggers on keyup for officeName and PC numb
   * @param event 
   */
  onKeyUp(event: any) {    
    if(event.target.value === '') {
      this.coreEmployeeSearchForm.controls['pcnum'].setValue('');
      this.coreEmployeeSearchForm.controls['officeName'].setValue('');
      this.currentSearchData.pcNumber = null;
      this.submitDisable = Object.values(this.currentSearchData).every(o => o === null || o === undefined || o === '');
    }
  }

  changeCoreServiceModal(event:any) {
    this.onAssignmentChangeEmit.emit(this.assignmnt);
    this.updateCoreServiceType(event);   
    this.coreService.setDataChangeFlag(false);
    this.flag = false;
    this.searchedFlag = false ;
  }

  onCancelUpdatePopup() {
    this.selectedCoreServiceType = this.lastSelectedCoreServiceType;
    this.coreEmployeeSearchForm.controls['type'].setValue(this.selectedCoreServiceType)
  }

  populateCoreServiceSearchDetails() {
    if(sessionStorage.getItem('currentUrl') !== null && sessionStorage.getItem('coreServiceSearchData') !== null)
    {
      let searchData = sessionStorage.getItem('coreServiceSearchData') as any;
      if(searchData != null)
        searchData = JSON.parse(searchData);      
      
      const lastEmployeeSearch = searchData;
      if (lastEmployeeSearch) {
        this.salesAssignment = lastEmployeeSearch.salesAssignement;
        this.searchByType = this.salesAssignment;
        this.coreEmployeeSearchForm.controls.searchBy.patchValue(this.salesAssignment);
        if (lastEmployeeSearch.pcnum) {
          this.selectPCNumber(lastEmployeeSearch.pcnum);
          }
        this.coreEmployeeSearchForm.controls['type'].setValue(lastEmployeeSearch.type);
        this.coreEmployeeSearchForm.controls['region'].setValue(lastEmployeeSearch.region);
        this.coreEmployeeSearchForm.controls['state'].setValue(lastEmployeeSearch.state);
        this.coreEmployeeSearchForm.controls['pcnum'].setValue(lastEmployeeSearch.pcnum);

        this.selectedCoreServiceType = lastEmployeeSearch.type;
        this.coreEmployeeSearchForm.controls['employeeName'].setValue(lastEmployeeSearch.employeeName);
        if (this.salesAssignment) {
          this.disaledSubmitBtnSales = false;
          } else {
            this.submitDisable = false;
        }
        if(!this.commonService.coreEmployeeSearchIconClicked)
          this.searchCoreEmployee();
        else {
          sessionStorage.removeItem('currentUrl');
          sessionStorage.removeItem('coreServiceSearchData');    
          this.route.navigateByUrl('/portal');
        }
      }
    }
    this.commonService.coreEmployeeSearchIconClicked = false;    
  }
}
